<div class="item shadow {{actionType}}" (click)="hasPermission ? openDialog() : null" [ngClass]="{'disabled': !hasPermission}">
  <div class="icon"><i class="icon-{{actionType}}"></i></div>
  <div class="text">{{actionText}}</div>
</div>
